import { useInView, useBooleanState } from '@cian/valuation-utils-component';
import loadable from '@loadable/component';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SkeletonContainer } from './containers/SkeletonContainer';
import { trackEstimationBlockExist } from './tracking';
import { checkAccessToAdmin, getOfferValuation, selectOfferValuationData } from '../../store/offerValuation';

/* istanbul ignore next */
export const OfferValuationContainerLoadable = loadable(() => import('./OfferValuationContainer'), {
  fallback: <SkeletonContainer />,
});

/**
 * Контроллер загрузки данных и маунта блока OfferValuation
 * Ходит в API за данными для блока. Делает это 1 раз сразу, при маунте.
 * Маунтит loadable компонент блока при попадании обертки в вьюпорт (заранее за 200px).
 * */
export const OfferValuationContainerLoader: React.FC = () => {
  const dispatch = useDispatch();
  const offerValuationData = useSelector(selectOfferValuationData);
  const [shouldMount, setShouldMount] = useBooleanState();
  /** За счет rootMargin маунт блока начнется немного заранее, когда блок приблизится на 200px к вьюпорту */
  const { ref, inView } = useInView({ triggerOnce: true, rootMargin: '200px' });

  React.useEffect(() => {
    if (inView && !shouldMount) {
      setShouldMount();
    }
  }, [inView, setShouldMount, shouldMount]);

  React.useEffect(() => {
    dispatch(getOfferValuation());
    dispatch(checkAccessToAdmin());
  }, [dispatch]);

  React.useEffect(() => {
    if (offerValuationData?.priceInfo) {
      trackEstimationBlockExist();
    }
  }, [offerValuationData]);

  if (!offerValuationData) {
    return null;
  }

  return <div ref={ref}>{shouldMount && <OfferValuationContainerLoadable />}</div>;
};

OfferValuationContainerLoader.displayName = 'OfferValuationContainerLoader';
